import React from "react";
import { TextField } from "components";
import { usePropertyContext } from "../../context";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { formatDollarStr } from "utils/formatDollar";
import moment from "moment";
import ButtonV2 from "elements/ButtonV2";

const AnnualHouseholdIncome = () => {
	const { details } = usePropertyContext();
	const { flowId, next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();
	const trackEvent = useEventTracker();

	const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
		const { value } = event.target;
		setSpecialFieldsValue({
			income_tax_history: [
				{
					...specialFieldsValue?.income_tax_history?.[0],
					tax_year: new Date().getFullYear() - 2,
					annual_household_income: parseFloat(value.replace(/[^0-9.]/g, "")),
				},
			],
		});
	};

	const handleSubmit = async () => {
		trackEvent({
			eventName:
				constants.EVENTS.Exemptions_Flow_Annual_Household_Income_Answer,
			data: {
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		next();
	};

	const buttonDisabled = React.useMemo(() => {
		return !specialFieldsValue?.income_tax_history?.[0]
			?.annual_household_income;
	}, [specialFieldsValue]);

	const showWarningMessage = React.useMemo(() => {
		if (flowId === "NEW_YORK_EXEMPTION") {
			if (
				specialFieldsValue &&
				specialFieldsValue?.income_tax_history?.[0]?.annual_household_income &&
				specialFieldsValue?.income_tax_history?.[0]?.annual_household_income >=
					500_000
			) {
				return true;
			}
		}

		return false;
	}, [specialFieldsValue, flowId]);

	const twoYearsAgo = React.useMemo(
		() => moment().subtract(2, "years").format("YYYY"),
		[]
	);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>What was your annual household income in {twoYearsAgo}?</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					Income means federal adjusted gross inome minus the taxable amount of
					total distributions from IRAs (individual retirement accounts and
					individual retirement annuities).
				</p>
				<TextField
					required
					label="Annual Household Income"
					placeholder="$"
					containerClassName="exemptions-card-input"
					autoComplete="off"
					value={formatDollarStr(
						specialFieldsValue?.income_tax_history?.[0]
							?.annual_household_income || ""
					)}
					onChange={handleChange}
				/>
			</div>
			{showWarningMessage && (
				<p className="sm exemptions-notification-message-rust">
					STAR Credit has an income limit of $500,000. Since you do not meet
					this requirement, we will try to find you opportunities to save in
					other ways.
				</p>
			)}
			<ButtonV2 size="large" disabled={buttonDisabled} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default AnnualHouseholdIncome;
